import { useMemo } from 'react';
import { FormattedMessage } from 'react-intl';
import { TravellerBearerDTO } from '@/api/trafikportalen';
import {
  IconOtherBearer,
  IconPaper,
  IconSmartcard,
  IconSmartphoneDevice,
} from '@/icons';
import { formatCardNumber } from '@/helpers/formatting';
import { cn } from '@/helpers/classnames';

interface BearerProps {
  bearer: TravellerBearerDTO;
  className?: string;
}

export const Bearer = ({ bearer, className }: BearerProps) => {
  const { type, serial } = bearer;

  const nameContent = useMemo(() => {
    if (bearer.name?.startsWith('Smartphone of traveller with id:')) {
      return <FormattedMessage defaultMessage="Smartphone" />;
    }
    if (!bearer.name && type === 'smartcard') {
      return (
        <i>
          <FormattedMessage defaultMessage="Anonymt resekort" />
        </i>
      );
    }
    return bearer.name;
  }, [bearer.name, type]);

  return (
    <div className={cn('flex flex-1 items-center gap-2', className)}>
      {type && ICONS[type]}
      <div className="flex max-w-fit flex-col items-start overflow-hidden">
        <p className="max-w-full truncate leading-5">{nameContent}</p>
        {serial ? (
          <p className="font-mono font-light leading-4 opacity-70">
            {formatCardNumber(serial)}
          </p>
        ) : null}
      </div>
    </div>
  );
};

const ICONS = {
  smartphone: <IconSmartphoneDevice className="size-5 min-w-5" />,
  smartcard: <IconSmartcard className="size-5 min-w-5" />,
  paper: <IconPaper className="size-5 min-w-5" />,
  other: <IconOtherBearer className="size-5 min-w-5" />,
};
